export const UPDATE_ORDER_ACTIVE_COMPONENT = 'UPDATE_ORDER_ACTIVE_COMPONENT';

export function updateOrderActiveComponent(step) {
  return {
    type: UPDATE_ORDER_ACTIVE_COMPONENT,
    payload: step,
  };
}
